import React from 'react';
import { StarIcon, QuoteIcon } from '../../../components/common/IconsComponent';

const testimonials = [
  {
    name: 'Sarah Ahmed',
    role: 'University Student',
    image: 'https://i.pravatar.cc/120?img=32',
    text: 'DoroosOnline transformed my learning experience. The teachers are incredibly knowledgeable and the platform is so easy to use. I improved my grades significantly!',
  },
  {
    name: 'Mohammed Khalil',
    role: 'High School Student',
    image: 'https://i.pravatar.cc/120?img=15',
    text: 'The flexibility of scheduling private lessons around my school hours has been amazing. My math tutor explains concepts in ways my school teachers never could.',
  },
  {
    name: 'Fatima Hassan',
    role: 'Working Professional',
    image: 'https://i.pravatar.cc/120?img=47',
    text: 'As someone learning a new language for work, the one-on-one sessions have been invaluable. My teacher adapts to my pace and focuses on what I need most.',
  },
  {
    name: 'David Cohen',
    role: 'Parent',
    image: 'https://i.pravatar.cc/120?img=68',
    text: 'Finding quality tutors for my children was always a challenge until we discovered DoroosOnline. The verified teachers give us peace of mind.',
  },
];

const TestimonialCard = ({ name, role, image, text }) => (
  <div className="flex flex-col gap-4 rounded-2xl border border-gray-100 bg-white p-5 shadow-sm transition duration-300 hover:shadow-md sm:p-6">

    {/* Header */}
    <div className="flex items-start justify-between gap-3">
      <div className="flex items-center gap-3">
        <img
          src={image}
          alt={name}
          className="h-12 w-12 flex-shrink-0 rounded-full object-cover ring-2 ring-indigo-100 sm:h-14 sm:w-14"
          loading="lazy"
        />
        <div>
          <h3 className="text-sm font-semibold text-slate-900 sm:text-base">{name}</h3>
          <p className="text-xs text-slate-400 sm:text-sm">{role}</p>
          <div className="mt-1.5 flex gap-0.5">
            {Array.from({ length: 5 }).map((_, i) => (
              <StarIcon key={i} className="h-3.5 w-3.5 fill-yellow-400 text-yellow-400" aria-hidden="true" />
            ))}
          </div>
        </div>
      </div>
      <QuoteIcon className="h-8 w-8 flex-shrink-0 text-indigo-200 sm:h-9 sm:w-9" aria-hidden="true" />
    </div>

    {/* Quote */}
    <p className="text-sm leading-relaxed text-slate-500 sm:text-base sm:leading-7">
      &quot;{text}&quot;
    </p>

  </div>
);

const Testimonials = () => (
  <section className="bg-gray-50 py-12 lg:py-20 py-12 lg:py-20" dir='ltr'>
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

      {/* Header */}
      <div className="mb-10 text-center sm:mb-12">
        <h2 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
          What Our Students Say
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-base text-slate-500 sm:mt-4 sm:text-lg">
          Join thousands of satisfied learners who achieved their goals with DoroosOnline
        </p>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 gap-4 sm:gap-5 lg:grid-cols-2">
        {testimonials.map((item) => (
          <TestimonialCard key={item.name} {...item} />
        ))}
      </div>

    </div>
  </section>
);

export default Testimonials;